<template>
  <router-link to="/" class="getlokal-brand">
    <span class="brand-mark">GL</span>
    <span class="brand-name">GetLokal</span>
  </router-link>
</template>

<script>
export default {};
</script>

<style scoped>
.getlokal-brand {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
  padding: 2px 0;
}

.brand-mark {
  width: 34px;
  height: 34px;
  border-radius: 9px;
  background: #900C27;
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: 13px;
  font-family: 'Plus Jakarta Sans', 'Montserrat', sans-serif;
  letter-spacing: 0.5px;
  flex-shrink: 0;
}

.brand-name {
  font-family: 'Plus Jakarta Sans', 'Montserrat', sans-serif;
  font-size: 17px;
  font-weight: 800;
  letter-spacing: -0.5px;
  color: #111318;
}
</style>

<style>
body.dark-only .brand-name {
  color: rgba(255,255,255,0.92) !important;
}
</style>
